<template>
  <div class="container">
    <h1 class="page-break">Overview</h1>
    <p v-if="$store.state.subscriberData.Submitted">
      Thank you for subscribing for the Wervingsdagen events of 2020.
      A confirmation mail is send to your mail address.
      Mid October, the company selection for both the Career Expo and the Interviewing Days will be communicated by mail.
      Within this mail, you will receive more information about the required information which is needed for the company guide.
    <p v-else>
      In this overview, all the submitted information is displayed. Please check it carefully before submitting.
    </p>
    <h2 class="page-break">Your contact information</h2>
    <ContactView />
    <h2 class="page-break">Your selected studies</h2>
    <StudyView />
    <h2 class="page-break">Your selected package</h2>
    <PackageView />
    <router-link to="/packages" v-if="$store.state.subscriberData.Submitted">
      <button class="btn btn-secondary">Back</button>
    </router-link>
    <router-link to="/subscribe/interviewing-days-options" v-else-if="interviewingDays">
      <button class="btn btn-secondary">Back</button>
    </router-link>
    <router-link to="/subscribe/career-expo-options" v-else-if="careerExpo">
      <button class="btn btn-secondary">Back</button>
    </router-link>
    <router-link to="/subscribe/package-selection" v-else>
      <button class="btn btn-secondary">Back</button>
    </router-link>
    <button
      class="btn btn-primary"
      @click="submit"
      v-if="!$store.state.subscriberData.Submitted"
    >Submit</button>
    <button
      class="btn btn-primary"
      @click="print"
      v-if="$store.state.subscriberData.Submitted"
    >Print</button>
  </div>
</template>

<script>
import ContactView from "@/components/ContactView.vue";
import StudyView from "@/components/StudyView.vue";
import PackageView from "@/components/PackageView.vue";

export default {
  name: "overview",
  components: {
    ContactView,
    StudyView,
    PackageView
  },
  computed: {
    careerExpo() {
      return this.$store.getters.hasEvent("career-expo");
    },
    interviewingDays() {
      return this.$store.getters.hasEvent("interviewing-days");
    }
  },
  methods: {
    submit() {
      this.$store.state.loaded = false;
      this.$store.state.subscriberData.Submitted = true;
      window.scrollTo({
        top: 0,
        left: 0
      });
      this.$store.dispatch("saveState").then((result) => {
        return this.$store.commit("reloadPackage", result.data);
      });
    },
    print() {
      window.print();
    }
  }
};
</script>

<style lang="scss">
@media print {
  @page {
    size: A4;
    margin: 0;
  }

  #subscription-progress {
    display: none;
  }

  .page-break {
    page-break-before: always;
    margin-top: 140px;
  }

  .btn {
    display: none !important;
  }

  #head {
    width: 100% !important;
    position: fixed !important;
    top: 0 !important;
    -webkit-print-color-adjust: exact;
  }

  #foot {
    img {
      display: none;
    }

    .footer-bg {
      width: 100% !important;
      position: fixed !important;
      bottom: 0 !important;
      -webkit-print-color-adjust: exact;
    }
  }
}
</style>
